/**
 * gcpDiscount模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const gcpDiscount = {
   // 查询公司折扣配置
   selectDiscountConfig(id, params) {
     let param = new URLSearchParams();
     param.append(id, params);
     return $http.post(`${global.API_URL}/sme/discount/selectDiscountConfig`,param);
   },
   // 修改公司折扣配置
   updateDiscountConfig(params) {
     return $http.post(`${global.API_URL}/sme/discount/updateDiscountConfig`,params);
   }
 }
 
 export default gcpDiscount;
 


// WEBPACK FOOTER //
// ./src/api/gcpDiscount.js